import React,{Component} from 'react';
import './style.less';
import util from 'src/util/util';


class Notification extends Component {
	constructor() {
		super();
		this.state = {
			duration: 2000
		};
		this.hideNotice = this.hideNotice.bind(this);
	}
	componentDidMount(){
		this.addNotice();
	}
	componentDidUpdate(prevProps, prevState){
		if(this.props.keyTime !== prevProps.keyTime){  //新的notice
			if(this.props.type === 'show'){
				this.addNotice();
			}else{
				this.hideNotice();
			}
		}else{

		}

	}
	addNotice() {
		let notice = this.props;
		this.setState({
			toastInfo: notice,
			show: true
		}, () => {
			//content动画
			this.contentAnimateLoop && clearTimeout(this.contentAnimateLoop);
			this.contentAnimateLoop = setTimeout(() => {
				this.setState({
					showContent: true
				}, () => {
					this.hideLoop && clearTimeout(this.hideLoop);
					this.hideLoop = setTimeout(() => {
						this.hideNotice();
					}, notice.duration || this.state.duration);
				});
			}, 20);
		});
	}

	hideNotice(key) {
		this.hideLoop && clearTimeout(this.hideLoop);
		this.contentAnimateLoop && clearTimeout(this.contentAnimateLoop);
		this.setState({
			show: false,
			showContent: false
		},()=>{
			this.props.onClose && this.props.onClose();
		});
	}

	render() {
		let toastInfo = this.props;
		let classNames1 = util.getClassNames({
			'show': this.state.show,
			'style-1': toastInfo.style === 1
		});
		let classNames2 = util.getClassNames({
			'toast-box': true,
			'show': this.state.showContent,
		});
		return (
			<div id='tf-component-toast' className={classNames1} >
				<div className={classNames2}>
					<div className='toast-wrapper' onTransitionEnd={this.onTransitionEnd}>
						{
							(toastInfo && toastInfo.content) || ''
						}
					</div>
				</div>
			</div>
		);
	}
}


Notification.showNotice = (notice)=>{
	Notification.addNotice(notice);
};

export default Notification;



// WEBPACK FOOTER //
// ./src/components/public/toast/notification.js